// src/components/Timer/ModeSelector.js

import React from 'react';

function ModeSelector({ mode, setMode }) {
  const handleModeChange = (newMode) => {
    setMode(newMode); // Timer update happens in TimerApp's useEffect
  };

  return (
    <div className="mode-selector">
      <button
        className={mode === 'Pomodoro' ? 'active' : ''}
        onClick={() => handleModeChange('Pomodoro')}
      >
        Timer
      </button>
      <button
        className={mode === 'Short Break' ? 'active' : ''}
        onClick={() => handleModeChange('Short Break')}
      >
        Short Break
      </button>
      <button
        className={mode === 'Long Break' ? 'active' : ''}
        onClick={() => handleModeChange('Long Break')}
      >
        Long Break
      </button>
    </div>
  );
}

export default ModeSelector;
